import { connect } from 'react-redux'
import ProductsFiltersBottom from '../components/ProductsFiltersBottom'
import { toggleFilter, clearFiltersByCategory } from '../actions/productsActions'
import { getOrderedFilters } from '../selectors/defaultSelectors'

const mapStateToProps = function (store) {
  const products = store.products.present
  const { loading, filters } = products
  return {
    isLoading: loading,
    filters: getOrderedFilters(filters),
  }
}
const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    toggleFilter: (params) => dispatch(toggleFilter(params)),
    clearFiltersByCategory: (params) => dispatch(clearFiltersByCategory(params)),
  }
}
const ConnectedProductsFiltersBottom = connect(mapStateToProps, mapDispatchToProps)(ProductsFiltersBottom)

export default ConnectedProductsFiltersBottom
